{
  "accept": "Agree",
  "activate account": "Activate your account",
  "added doctor to favorite doctror": "{name} has been registered as a doctor of interest.",
  "addFiles": "Attached file",
  "after payment is confirmed, completed.": "The registration will be completed after confirming the payment.",
  "agree": "Agree",
  "agree to all terms and conditions": "I agree to all the terms and conditions.",
  "agree to all terms and conditions.": "I agree to all the terms and conditions.",
  "agreeAll": "Agree all",
  "Agreement": "Terms of use",
  "Agreement Content": "Terms and Conditions",
  "allowingRecive": "Agree to receive",
  "attach files": "Attaching files",
  "attached files": "Attaching files",
  "Attachments": "Attachment",
  "available email": "Available email",
  "back": "Back",
  "birthDate": "Date for birth",
  "CalcelHeader": "Do you want to cancel?",
  "cancel": "Cancellation",
  "Cancel": "Cancellation",
  "cancel payment and reservation": "Cancellation and cancellation of payment",
  "cancel reservation": "Reservation cancellation",
  "canceled": "Cancellation",
  "Canceled": "Cancellation",
  "change": "Change",
  "change docor": "Change doctor",
  "change password": "Change password",
  "changed password": "Your password has been changed.",
  "changePassword": "Change password",
  "check email": "Please check your {email} mail.",
  "check email verificaion": "Please check the duplicate email.",
  "check payment": "Payment confirmation",
  "check prescription": "Check the prescription",
  "check spam mail box": "Please check your spam mailbox.",
  "Check your email or password": "Check your email or password.",
  "CheckingItNow": "Checking",
  "chief complaint": "Main symptom",
  "chief complaint & files": "Attaching symptoms and files.",
  "close": "Close",
  "complete": "Complete",
  "complete to sign-up": "Click the button to complete your membership registration.",
  "Completed": "Reply completed",
  "confirm": "Confirm",
  "confirm cancel reservation": "Modification is not possible after cancellation of reservation. ^ Would you like to cancel this reservation?",
  "confirm delete file": "Are you sure you want to delete this file?",
  "confirm new password": "Confirm new password",
  "confirm reservation": "Confirm reservation",
  "confirm withdrawal": "Are you sure you want to withdrawal membership?",
  "confirm2": "Check the contents",
  "confirmed within one hour on average": "Confirmation within an hour on average",
  "confirmemail": "Check your email",
  "connected count to room": "{count} participants connected.",
  "Copied to clipboard": "Copied to clipboard",
  "copy share link": "Copy Share Link",
  "DataType": "Data type",
  "date (from)": "Date(from)",
  "date (to)": "Date(to)",
  "dayNames": "Sunday,Monday,Tuesday,Wednesday,Thursday,Friday,Saturday",
  "dayNamesMin": "Sun,Mon,Tue,Wed,Thu,Fri,Sat",
  "dayNamesShort": "Sun,Mon,Tue,Wed,Thu,Fri,Sat",
  "DCS": "Remote Cooperation Service",
  "default": "Default",
  "desired date": "Desired date of consultation",
  "desired date/time": "Desired date/hour",
  "desired date/time can be selected after doctor selected": "You can select and modify the desired date and time after selecting a doctor.",
  "desired time": "Desired consultation hours",
  "did you not receive verification code via email": "Didn't you get the authentication number by email?",
  "didnt receive verification email": "Didn't you get the authentication mail?",
  "direct input": "Direct input",
  "Dispense": "Prepared",
  "do change": "To make changes",
  "do not show one week": "Do not show for 7 days",
  "do save": "Save",
  "doctor": "Doctor",
  "doctor name": "Doctor's name",
  "doctor or dept": "A doctor or medical department",
  "doctor response": "Doctor's reply",
  "download": "Download",
  "Drag and drop files to here to upload.": "Drag the attachment to the mouse or click the Select File button.",
  "drop files to here": "Drag and drop",
  "edit": "Modify",
  "edit personal information": "Personal information modification",
  "edit requested data": "Modifying collaborative appointments",
  "email": "Email",
  "email already in use": "Email already in use",
  "email confirmed": "Your mail authentication has been verified.",
  "EmailCheck": "email duplicate verification",
  "EmailSendOK": "An email has been sent to the email you entered.",
  "emptyMessage": "",
  "enter at least two characters without spaces": "Please enter at least two characters excluding spaces.",
  "error": "Error",
  "Error": "Error",
  "error occured. please retry later": "Error occurred, please try again later.",
  "expire date": "Expire Date",
  "Failed to copy to clipboard": "Failed to copy to clipboard",
  "failed to save": "Save failed",
  "failed to sign up": "Failed to sign up for membership",
  "familyName": "Family name",
  "favorite doctors": "A doctor of interest",
  "female": "Woman",
  "fetch failed": "Unable to connect to service.",
  "file-list": {
    "desc": {
      "a": "DICOM images are compressed into a .ZIP file and uploaded",
      "b": "When you can't see the video you filmed on your iPhone",
      "c": "here",
      "d": "click",
      "e": "[Capturing media]",
      "f": "for"
    }
  },
  "FileAttachments": "Attaching symptom pictures",
  "FileCancel": "Cancel attachment",
  "FileChoose": "Select files",
  "FileManager": "File management",
  "FileTitle": "File name",
  "FileType": "File type",
  "Fileupload": "File upload",
  "fill-form-data": "Please enter the required information for your subscription.",
  "filtered by dept": "Search by medical department",
  "finding keywords (requested)": "Doctor, Hospital, Department, etc.",
  "finished sign up": "It will be completed.",
  "first name": "First name",
  "firstName": "First name",
  "fold": "Fold",
  "forgotPassword": "Forgot your Password?",
  "ForOpinion": "Application for 2nd opinion",
  "from date": "Date(from)",
  "full name": "Name",
  "home": "Home",
  "home-intro-1": "A different treatment than ever before,",
  "home-intro-2": "a special non-face-to-face treatment HESEL",
  "how to take appointment for non-face-to-face cooperation": "Select a specialist and send the symptoms to complete the application for a consultation appointment.",
  "impossible to confirm": "Unable to verify",
  "InfoModify": "Modifying membership information",
  "input chief complaint": "Enter main symptom",
  "input new password": "Please enter a new password.",
  "input new password confirm": "Please enter the new password again.",
  "input old password": "Please enter an existing password.",
  "input your email address": "Please enter the email you entered when you signed up.",
  "input-email": "Please enter your email address.",
  "input-password": "Please enter your password.",
  "insertDateTime": "Application date",
  "invited-info": "Please join after entering the participant name and invitation password. You can join after the inviter creates the room.",
  "invited-title": "Invited video chat",
  "inviter": "Inviter",
  "join": "Sign up",
  "join chat": "Join",
  "korea standard time": "KST",
  "last name": "Last name",
  "LastOrder": "Recent payment",
  "legal": "Legal",
  "List of Doctors": "Choose a doctor",
  "login failed": "Login failed",
  "make sure the correct email address": "Please check if you have registered the correct email address.",
  "male": "Man",
  "medically-vulnerable": "A vulnerable area of medical care",
  "mofidy requested second opinion": "Modifying application for opinion",
  "monthNames": "January,February,March,April,May,June,July,August,September,October,November,December",
  "monthNamesShort": "Jan,Feb,Mar,Apr,May,Jun,Jul,Aug,Sep,Oct,Nov,Dec",
  "more": "More",
  "my doctors": "Doctor of interest",
  "my page": "My page",
  "MyPage": "My page",
  "name": "Name",
  "new password": "New password",
  "newPassword": "New password",
  "newPasswordConfirm": "Confirm new password",
  "newRequest": "New request",
  "newRequestOnlineCare": "Application for reservation",
  "newRequestSecondOpinion": "Apply 2nd opinion",
  "next": "Next",
  "Next": "Next",
  "No": "No",
  "non-face-to-face cooperation": "Non-face-to-face cooperation",
  "not confirmed email": "Unable to verify email",
  "ok": "OK",
  "online-care-intro-1": "Treatment of chronic diseases such as high blood pressure and diabetes, and general diseases such as colds",
  "online-care-intro-2": "Video non-face-to-face collaboration on reservation date",
  "OnlineCare": "Non-face-to-face cooperation",
  "Page not found": "Page not found.",
  "paid history": "Payment history",
  "paid list": "Payment history",
  "paid then completed": "The registration will be completed after payment.",
  "participant": "Participant",
  "password": "Password",
  "password changed": "Your password has been changed.",
  "Password not correct": "Password doesn't match.",
  "password was changed or expired": "Password has already been changed or the change period has expired.",
  "password-rules": "Includes at least 6 digits, alphabets and numbers",
  "passwordConfirm": "Confirm password",
  "pay": "Payment",
  "payment": "Payment",
  "PayReady": "Waiting for payment",
  "pharmacy": "Pharmacy",
  "PharmacyNone": "None",
  "phoneNumber": "Mobile number",
  "pi-agreement": "Consent to provide personal information",
  "prescription": "Prescription",
  "Prev": "Previous",
  "previous": "Previous",
  "privacy": "Personal information processing policy",
  "Privacy Policy": "Personal information processing policy",
  "Privacy Policy Content": "Personal information processing policy",
  "proceeding": "Ongoing",
  "profile": "Personal information",
  "quick": "Fast",
  "quick reservation description": "Apply for medical treatment by selecting your preferred doctor and preferred date/time.",
  "ReceptionCompleted": "Received",
  "ReceptionSaveHeader": "Would you like to register?",
  "recommendted browsers": "Recommended browser",
  "refresh": "Refresh",
  "refund and reject": "Refund completed and returned",
  "refunded": "Refund",
  "Refused": "Returned",
  "registrationcompleted": "Sign up complete",
  "reject": "Withdrawing",
  "rejected": "Returned",
  "remember me": "Remember me",
  "remove": "Delete",
  "Remove": "Delete",
  "request": "Request",
  "request appointment": "Registering",
  "request comments": "Reservation Comments",
  "request kind": "Type",
  "request quick reservation": "An early application for medical treatment",
  "request reservation": "Acceptance of applications",
  "request second opinion": "Secondary opinion request",
  "requested": "Requested",
  "Requested": "Requested",
  "requested and wait payid": "Waiting for application and payment",
  "requested count": "Requested count",
  "requested list": "Requested history",
  "RequestedQuick": "Quick medical examination",
  "required": "Required",
  "Required information is required": "Please enter the required information.",
  "required phone number for servie": "Please enter your mobile phone number to use the service.",
  "resend verification email": "Resend authentication mail",
  "reserved date/time": "Reservation date/time",
  "reset": "Deselect",
  "reset password": "Initialize password",
  "resetpassword": "Change password",
  "resetPasswordCompleted": "Password change successful",
  "respond count": "Reply completed",
  "respond list": "Completion history",
  "respondDateTime": "Date of reply",
  "responded": "Reply completed",
  "response": "Reply",
  "Result": "Result",
  "Return": "Return",
  "room name": "Room Name",
  "room status": "Room Status",
  "save": "Save",
  "save response": "Save reply",
  "Saved": "Saved",
  "saved requesting reservation": "Your application has been accepted.",
  "SavedFavorites": "Saved to one's family doctor.",
  "SaveHeader": "Do you want to save it?",
  "Scheduled": "Reservation confirmed",
  "scheduled date/time": "Date and time of reservation",
  "scheduledDatetime": "Date and time of reservation",
  "search": "Search",
  "search failed": "Search error",
  "second opinion": "Second Opinion",
  "second-opinion-intro-1": "Based on examination files such as cancer treatment and surgery at other hospitals",
  "second-opinion-intro-2": "Specialist opinion is required (3 to 7 days)",
  "SecondOpinion": "Second Opinion",
  "SecondOpinion2": "Second Opinion",
  "Select a Dept": "Select a medical department",
  "select a hospital": "Select the hospital",
  "Select a hospital": "Select the hospital",
  "select a hospital to requesting": "Please select the hospital for medical treatment.",
  "select desired date/time": "Select the desired date and time.",
  "select doctor": "Select the doctor",
  "select hopital and doctor": "Select the hospital and the doctor.",
  "sent confirming email": "Authentication mail has been sent.",
  "sent verification email": "Authentication mail has been sent.",
  "serious illness": "A serious illness",
  "sex": "Gender",
  "sexF": "Woman",
  "sexM": "Man",
  "show detail": "Show detail",
  "show detail profile": "View profile details",
  "sign in": "Sign in",
  "Sign in": "Sign in",
  "sign out": "Sign out",
  "sign up": "Sign up",
  "sign-in-titl-1": "Allows you to select a treatment time to receive non-face-to-face consultation ",
  "sign-in-titl-2": "and provide a second opinion for severe diseases.",
  "sign-up": "sign up",
  "signin": "Sign in",
  "Signout": "Sign out",
  "signup": "Sign up",
  "signup-title": "Aren't you a member yet?",
  "signup-title-1": "For member management, we would like to collect, use, and provide personal information as follows.",
  "signup-title-2": "Please read the contents carefully and decide whether you agree or not.",
  "sms": "SMS",
  "Status": "Status",
  "submit": "Submit",
  "submit application": "Registering for medical treatment",
  "take appointment": "A cooperative appointment",
  "take appointment for non-face-to-face cooperation": "Application for a cooperative appointment",
  "take average one week": "It takes 3-7 days",
  "terms of use": "Terms of use",
  "there is no selectable doctors": "There is no doctor available to choose from.",
  "time standard": "Standard",
  "title": "Title",
  "to date": "Date(to)",
  "toggle favarite doctor": "Click one more to remove from the list of doctors of interest.",
  "totalCallTime": "Calling time",
  "Unable to load user": "User not found.",
  "unfold": "Open",
  "update is completed": "Update is completed..",
  "User account locked out": "Login attempt exceeded, please try again in a few minutes.",
  "User not found": "User not found",
  "userInfo": "User information",
  "userName": "User name",
  "validateError": "Please enter required entry.",
  "Video": "Video",
  "video chat": "Video chat",
  "view prescription": "View prescription",
  "withdrawal": "Withdrawal",
  "withdrawal info1": "If you withdraw from membership,",
  "withdrawal info2": "all of your medical records will be deleted and cannot be recovered.",
  "WithdrawalHeader": "I'm leaving the membership.",
  "Yes": "Yes",
  "Your email is not verified": "HESEL sent an email to the email you signed up for. \n Please open the email and click the [Activate Account] button. \n Next, you can log in.",
  "requested detail information": "Requested Detail Information",
  "Phone number": "Phone number",
  "Links Komef": "Connect by KOMEF",
  "face-to-face cooperation": "Face-to-face cooperation",
  "appointmentTypes": {
    "appointment": "Appointment",
    "telemedicine": "Non face-to-face cooperation"
  },
   "hospital & dept": "Hospital / Department"
}
